import { airline_logo_version } from '@/constants/icon'

const isValidAirlineLogo = (logo?: string | null): logo is string =>
    typeof logo === 'string' && logo !== '' && logo !== 'undefined' && logo !== 'null'

const AIRLINES_WITH_LOGO_BORDER = new Set(['UL'])

export const shouldShowAirlineLogoBorder = (airlineCode?: string | null): boolean =>
    !!airlineCode && AIRLINES_WITH_LOGO_BORDER.has(airlineCode)

export const getFlightLogoUrl = (logo?: string | null, isCircleLogo: string = '') => {
    if (!isValidAirlineLogo(logo)) {
        return isCircleLogo
            ? `https://static-assets-ct.flixcart.com/ct/assets/resources/images/logos/air-logos/svg_logos/${isCircleLogo}/default_airline.svg?v=${airline_logo_version}`
            : `https://static-assets-ct.flixcart.com/ct/assets/resources/images/logos/air-logos/DEFAULT_2x.png?v=${airline_logo_version}`
    }
    logo = logo.replace('3L', 'G9')
    if (!isCircleLogo)
        return `https://static-assets-ct.flixcart.com/ct/assets/resources/images/logos/air-logos/svg_logos/${logo}.svg?v=${airline_logo_version}`
    return `https://static-assets-ct.flixcart.com/ct/assets/resources/images/logos/air-logos/svg_logos/${isCircleLogo}/${logo}.svg?v=${airline_logo_version}`
}
